export const enum SelectedViewSource {
  Dropdown = 'dropdown',
  SavedViews = 'saved_views',
  URL = 'url',
}
